<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-card-title>
            <h2>{{ $t("reset_password_title") }}</h2>
          </v-card-title>
          <div v-if="password_reset_in_progress">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="submitNewPassword"
            >
              <v-card-text>
                <v-text-field
                  v-model="new_password1"
                  :type="'password'"
                  :rules="new_password1Rules"
                  :error-messages="new_password1Errors"
                  :label="$t('password')"
                  required
                  @change="validatePassword1"
                />
                <v-text-field
                  ref="new_password2"
                  v-model="new_password2"
                  :type="'password'"
                  :rules="new_password2Rules"
                  :error-messages="new_password2Errors"
                  :label="$t('password_verification')"
                  required
                  @change="validateAll"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn class="primary" type="submit" :disabled="!valid">{{
                  $t("reset_password_submit")
                }}</v-btn>
              </v-card-actions>
            </v-form>
          </div>
          <div v-else>
            <v-card-text>
              {{ $t("password_reset_done") }}
            </v-card-text>
            <v-card-actions>
              <v-btn class="primary" @click.native="goToLogin()">{{
                $t("go_to_login")
              }}</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <BackendConnector ref="backend" />
  </v-container>
</template>

<script>
export default {
  name: "ResetPassword",
  components: {},
  data() {
    return {
      password_reset_in_progress: true,
      valid: false,
      new_password1: "",
      new_password1Rules: [
        v => !!v || this.$t("password_required"),
        v => v.length >= 8 || this.$t("password_at_least", ["8"])
      ],
      new_password1Errors: [],
      new_password2: "",
      new_password2Rules: [v => !!v || this.$t("password_required")],
      new_password2Errors: []
    };
  },
  mounted() {
    this.$i18n.locale = this.$store.getters.getLanguage;
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case "LANG":
          if (this.$i18n) {
            this.$i18n.locale = mutation.payload;
          }
          break;
      }
    });
  },
  methods: {
    submitNewPassword() {
      let url =
        process.env.VUE_APP_ROOT_API +
        "/users/rest-auth/password/reset/confirm/";
      let data = {
        uid: decodeURIComponent(this.$route.params.uidb64),
        token: this.$route.params.token,
        new_password1: this.new_password1,
        new_password2: this.new_password2
      };
      // Use the Fetch api instead of the standard backend app, because
      // we explicitely do not want to send credentials or cookies
      fetch(url, {
        method: 'post',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'omit'
      }).then(response => {
        if (response.ok) {
          this.password_reset_in_progress = false;
        } else {
          response.json().then(response_data => {
            let errorHandled = false;
            if (response_data.new_password1) {
              this.new_password1Errors = response_data.new_password1;
              this.valid = false;
              errorHandled = true;
            }
            if (response_data.new_password2) {
              // django appears to respond to the second one in case of problems,
              // so we move the error to the first one ourselves
              this.new_password1Errors = response_data.new_password2;
              this.valid = false;
              errorHandled = true;
            }
            if (response_data.token) {
              this.new_password1Errors = this.$t("bad_security_token");
              errorHandled = true;
            }
            if (!errorHandled) {
              alert("Unhandled error: " + JSON.stringify(response_data));
            }
          })
        }
      }).catch(error => {
        alert("Unable to send request: " + JSON.stringify(error));
      });
    },
    checkPasswords() {
      if (this.password1 === this.password2) {
        this.password2Errors = [];
        this.valid = true;
        return true;
      } else {
        this.password2Errors = [this.$t("passwords_dont_match")];
        this.valid = false;
        return false;
      }
    },
    validatePassword1() {
      this.password1Errors = [];
      // return this.validateAll()
    },
    validateAll() {
      this.valid = this.checkPasswords() && this.$refs.form.validate();
      return this.valid;
    },
    goToLogin() {
      this.$router.push({ path: "/", query: { login: "1" } });
    }
  }
};
</script>
